import React, { useEffect, useState } from "react";
import "./All_Product.css";
import Product_card from "../../common-components/product_card/Product_card";
import Filter_btn from "../../common-components/common_btn/filter_btn/Filter_btn";
import { faBarsStaggered, faFilter } from "@fortawesome/free-solid-svg-icons";
import Filter_offcanvas from "./filter_offcanvas/Filter_offcanvas";
import Sort_offcanvas from "./sort_offcanvas/Sort_offcanvas";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../../../features/products/productsSlice";
import Product_Info_Card from "../../common-components/product_info_card/Product_Info_Card";

function All_Product({ selectId }) {
  const { id } = useParams();
  const allProducts1 = [
    {
      imgSrc: "/assets/images/product/ghee.png",
      productName: "Bilona Cow Ghee – Made from A2 Milk of Desi Cows",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/rice.png",
      productName: "Kalanamak Rice – Rich in Iron & Low Glycemic Index",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/daal.png",
      productName: "Desi Tuar Dal – Naturally Grown, Unpolished",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/ginger.png",
      productName: "Black Turmeric – Boosts Immunity & Inflammation Relief",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    // Add more products as needed
    {
      imgSrc: "/assets/images/product/ghee.png",
      productName: "Bilona Cow Ghee – Made from A2 Milk of Desi Cows",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/rice.png",
      productName: "Kalanamak Rice – Rich in Iron & Low Glycemic Index",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/daal.png",
      productName: "Desi Tuar Dal – Naturally Grown, Unpolished",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/ginger.png",
      productName: "Black Turmeric – Boosts Immunity & Inflammation Relief",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },

    // Add more products as needed
    {
      imgSrc: "/assets/images/product/ghee.png",
      productName: "Bilona Cow Ghee – Made from A2 Milk of Desi Cows",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/rice.png",
      productName: "Kalanamak Rice – Rich in Iron & Low Glycemic Index",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/daal.png",
      productName: "Desi Tuar Dal – Naturally Grown, Unpolished",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
    {
      imgSrc: "/assets/images/product/ginger.png",
      productName: "Black Turmeric – Boosts Immunity & Inflammation Relief",
      priceText: "200",
      kgText: "1",
      savingPrice: "20",
    },
  ];

  const [showFilter, setShowFilter] = useState(false);
  const [showSort, setShowSort] = useState(false);

  const handleShow = () => {
    setShowFilter(true);
    setShowSort(false);
  };

  const handleShowSort = () => {
    setShowSort(true);
    setShowFilter(false);
  };

  const handleClose = () => {
    setShowFilter(false);
    setShowSort(false);
  };

  const handleCloseSort = () => {
    setShowSort(false);
    setShowFilter(false);
  };
  const [sortOrder, setSortOrder] = useState(); 
  const location = useLocation();
  const allProducts = useSelector((state) => state.product.allProducts);
  const queryParams = new URLSearchParams(location.search);
  const searchValue = queryParams.get("search");
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getAllProducts({
        name: searchValue,
        category_id: selectId,
        sortBy: sortOrder,
      })
    );
  }, [dispatch, selectId, searchValue]);

  // var filteredProduct = allProducts?.data?.slice().filter((product) => product.p_category_id === selectId);

  return (
    <>
      <section className="All_Product">
        <div className="container-fluid">
          <div className="filter_holder">
            {/* <div className="filter_btn_holder">
              <Filter_btn
                btnText="Filter"
                icon={faFilter}
                onClick={handleShow}
              />
            </div> */}

            <div className="filter_btn_holder">
              <Filter_btn
                btnText="Sort"
                icon={faBarsStaggered}
                onClick={handleShowSort}
              />
            </div>
          </div>
          <div className="">
            <div className="all_prods_holder">
              {allProducts?.data && allProducts?.data?.length > 0 ? (
                <div className="row">
                  {allProducts?.data?.map((product, index) => (
                    <div className="col-lg-3 col-md-4 col-6">
                      <div className="product_card_holder p-1">
                        <Product_Info_Card
                          product={product}
                          id={product.id}
                          imgSrc={process.env.REACT_APP_IMG_URL + product.image}
                          vdoSrc={process.env.REACT_APP_IMG_URL + product.video}
                          productName={product.name}
                          priceText={product.Product_Variants[0]?.price}
                          mrp={product.Product_Variants[0]?.mrp}
                          kgText={product.Product_Variants[0]?.name}
                          savingPrice={
                            parseFloat(product.Product_Variants[0]?.mrp || 0) -
                            parseFloat(product.Product_Variants[0]?.price || 0)
                          }
                        />
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="no_product_available_holder text-center w-100">
                  <h3>No Product Available</h3>
                </div>
              )}
            </div>

            {/* old code */}
            {/* <div className="row">
              {allProducts?.data?.length > 0 ? (
                allProducts.data.map((product, index) => (
                  <div
                    className="col-lg-3 col-md-4 col-sm-6 col-6 px-md-2 px-1"
                    key={index}
                  >
                    <Product_card
                      product={product}
                      id={product.id}
                      imgSrc={process.env.REACT_APP_IMG_URL + product.image}
                      productName={product.name}
                      priceText={product.Product_Variants[0]?.price}
                      kgText={product.Product_Variants[0]?.name}
                      savingPrice={
                        parseFloat(product.Product_Variants[0]?.mrp) -
                        parseFloat(product.Product_Variants[0]?.price)
                      }
                    />
                  </div>
                ))
              ) : (
                <div className="no_product_available_holder">
                  <h3>No Product Available</h3>
                </div>
              )}
            </div> */}

            {/* {
              (selectId == null) ? allProducts?.data?.map((product, index) => (
                <div className="col-lg-3 col-md-4 col-sm-6 col-6" key={index}>
                  <Product_card
                    product={product}
                    id={product.id}
                    imgSrc={process.env.REACT_APP_IMG_URL + product.image}
                    productName={product.name}
                    priceText={product.Product_Variants[0]?.price}
                    kgText={product.Product_Variants[0]?.name}
                    savingPrice={parseFloat(product.Product_Variants[0]?.mrp) - parseFloat(product.Product_Variants[0]?.price)}
                  />
                </div>

              )) : allProducts?.data?.map((product, index) => (
                <div className="col-lg-3 col-md-4 col-sm-6 col-6" key={index}>
                  <Product_card
                    product={product}
                    id={product.id}
                    imgSrc={process.env.REACT_APP_IMG_URL + product.image}
                    productName={product.name}
                    priceText={product.Product_Variants[0]?.price}
                    kgText={product.Product_Variants[0]?.name}
                    savingPrice={parseFloat(product.Product_Variants[0]?.mrp) - parseFloat(product.Product_Variants[0]?.price)}
                  />
                </div>
              ))
            }
           {allProducts?.data.length < 0 &&( <div className="no_product_available_holder">
              <h3>No Product Available</h3>
            </div>)}
            */}
          </div>
        </div>
      </section>

      {/* Pass props to control offcanvas */}
      <Filter_offcanvas show={showFilter} handleClose={handleClose} />
      <Sort_offcanvas
        selectId={selectId}
        show={showSort}
        handleClose={handleCloseSort}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
      />
    </>
  );
}

export default All_Product;
